import Vue from 'vue';

import { assign, findIndex, get } from 'lodash';
import { updateArrayItemByID } from 'utils/array';
import * as api from 'api/api-persons';
import * as types from '../mutation-types';

const removeMeasurementFromState = (state, mesurementID) => {
  const index = findIndex(state.data.list, item => item.id === mesurementID);
  console.log('removeMeasurementFromState', index, state, mesurementID);
  if (index !== -1) {
    // state.data.list.splice(index, 1);
    // state.data.chart.splice(index, 1);
    Vue.delete(state.data.list, index);
    Vue.delete(state.data.chart, index);
  }
};

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: [],
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  PersonMeasurements: state => id => state[id],
};

const actions = {
  GetPersonMeasurements({ commit }, params) {
    const type = params.type;
    const id = params.id;
    const query = params.query;

    commit(types.FETCH_PERSON_MEASUREMENTS_START, { id });
    api.getPersonMeasurements(
      type,
      id,
      query,
      (response) => {
        commit(types.RECEIVE_PERSON_MEASUREMENTS, { id, response });
      },
      (description, status, error) => {
        commit(types.FETCH_PERSON_MEASUREMENTS_ERROR, { id, error });
      },
    );
  },
  AddMeasurementToPersonMeasurements({ commit }, { id, response }) {
    console.log('AddMeasurementToPersonMeasurements', response);
    commit(types.ADD_MEASUREMENT_TO_PERSON_MEASUREMENTS, { id, response });
  },
  EditMeasurementToPersonMeasurements({ commit }, { id, response }) {
    console.log('EditMeasurementToPersonMeasurements', response);
    commit(types.EDIT_MEASUREMENT_TO_PERSON_MEASUREMENTS, { id, response });
  },
  DeleteMeasurementFromPersonMeasurements({ commit }, { id, measurementID }) {
    commit(types.DELETE_MEASUREMENT_FROM_PERSON_MEASUREMENTS, { id, measurementID });
  },
  ClearPersonMeasurementsStore({ commit }, { id }) {
    commit(types.CLEAR_PERSON_MEASUREMENTS_STORE, { id });
  },
};

const mutations = {
  [types.FETCH_PERSON_MEASUREMENTS_START](state, { id }) {
    if (state[id]) Vue.set(state, id, assign(state[id], neutralState, { fetching: true }));
    else Vue.set(state, id, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_PERSON_MEASUREMENTS_ERROR](state, { id, error }) {
    Vue.set(state, id, assign(state[id], neutralState, { error }));
  },
  [types.RECEIVE_PERSON_MEASUREMENTS](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { ready: true, data: response.data, meta: response.meta }));
  },
  [types.CLEAR_PERSON_MEASUREMENTS_STORE](state, { id }) {
    Vue.set(state, id, assign({}, initState));
  },
  [types.ADD_MEASUREMENT_TO_PERSON_MEASUREMENTS](state, { id, response }) {
    const list = get(state[id], 'data.list', false);
    const listItem = get(response, 'data.list');
    if (list) list.push(listItem);

    const chart = get(state[id], 'data.chart', false);
    const chartItem = get(response, 'data.chart');
    if (chart) chart.push(chartItem);
  },
  [types.EDIT_MEASUREMENT_TO_PERSON_MEASUREMENTS](state, { id, response }) {
    const list = get(state[id], 'data.list', false);
    const listItem = get(response, 'data.list');
    updateArrayItemByID(list, listItem);

    const chart = get(state[id], 'data.chart', false);
    const chartItem = get(response, 'data.chart');
    updateArrayItemByID(chart, chartItem);
  },
  [types.DELETE_MEASUREMENT_FROM_PERSON_MEASUREMENTS](state, { id, measurementID }) {
    removeMeasurementFromState(state[id], measurementID);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/persons/entities/person-measurements.js